module.exports = __webpack_public_path__ + "img/login-l.0b255e30.png";